import { createSlice } from "@reduxjs/toolkit";

export interface userStateType {
  loading: boolean;
  userLoading: boolean;
  user: any;
  successMessage: {};
  error: Error | null;
}
const initialState: userStateType = {
  loading: false,
  userLoading: false,
  successMessage: {},
  user: {},
  error: null,
};

export const userStateSlice = createSlice({
  name: "userStateSlice",
  initialState,
  reducers: {
    // GET USERINFO
    getUserInfo: (state) => {
      state.userLoading = true;
    },
    getUserInfoSuccess: (state, action) => {
      state.user = action.payload;
      state.userLoading = false;
    },
    getUserInfoError: (state, action) => {
      state.userLoading= false;
    },

    // UPDATE user
    updateUserInfo: (state, action) => {
      state.loading = true;
    },
    updateUserInfoSuccess: (state, action) => {
      state.loading = false;
    },
    updateUserInfoError: (state, action) => {
      state.loading = false;
    },

    // CHANGE password
    changePassword: (state, action) => {
      state.loading = true;
    },
    changePasswordSuccess: (state, action) => {
      state.loading = false;
    },
    changePasswordError: (state, action) => {
      state.loading = false;
    },

    // UPDATE LANGUAGE
    updateLanguage: (state, action) => {
      state.loading = true;
    },
    updateLanguageSuccess: (state, action) => {
      state.loading = false;
    },
    updateLanguageError: (state, action) => {
      state.loading = false;
    },
    // UPDATE TIMEZONE
    updateTimezone: (state, action) => {
      state.loading = true;
    },
    updateTimezoneSuccess: (state, action) => {
      state.loading = false;
    },
    updateTimezoneError: (state, action) => {
      state.loading = false;
    },
    // GET USERINFO
    getPhoneEmailExists: (state, action) => {
      state.loading = true;
    },
    getPhoneEmailExistsSuccess: (state, action) => {
      state.loading = false;
    },
    getPhoneEmailExistsError: (state, action) => {
      state.loading = false;
    },
  }
});

export const {
  updateUserInfo, updateUserInfoSuccess, updateUserInfoError,
  changePassword, changePasswordSuccess, changePasswordError,
  getUserInfo, getUserInfoSuccess, getUserInfoError, updateLanguage,
  updateLanguageSuccess, updateLanguageError, updateTimezone,
  updateTimezoneSuccess, updateTimezoneError, getPhoneEmailExists,
  getPhoneEmailExistsSuccess, getPhoneEmailExistsError
} = userStateSlice.actions;

export default userStateSlice.reducer;